import { method } from "@/utils/request"

const api = {
  Get: "approval/template/list",
  Add: "approval/template",
  Del: "approval/template",
  Edit: "approval/template"
}

const url = process.env.VUE_APP_API_URL

/**
 * @param parameter
 * @returns {*}
 */
export function add(parameter) {
  return method(url)({
    url: api.Add,
    method: "post",
    data: {
      ...parameter
    }
  })
}

/**
 * @param {*} parameter
 */
export function del(ids) {
  return method(url)({
    url: api.Del,
    method: "delete",
    data: { approvalTemplateIDs: ids }
  })
}

/**
 * @param {*} parameter
 */
export function edit(parameter) {
  return method(url)({
    url: api.Edit,
    method: "put",
    data: parameter
  })
}

/**
 * @param {*} parameter
 */
export function get(parameter) {
  return method(url)({
    url: api.Get,
    method: "post",
    data: {
      pageNum: parameter.pageNum,
      pageSize: parameter.pageSize,
      templateName: parameter.templateName,
      approvalNum: Number(parameter.approvalNum),
      ccNum: Number(parameter.ccNum),
      creatorID: parameter.creatorID,
      times: parameter.times
    }
  })
}

export default {
  get,
  add,
  del,
  edit
}
